import { render } from "./DrinkTive.vue?vue&type=template&id=987b7516"
const script = {}

import exportComponent from "../../../../../../../../../projects/loyalzilla_admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/icons/package/DrinkTive.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "987b7516"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('987b7516', __exports__)) {
    api.reload('987b7516', __exports__)
  }
  
  module.hot.accept("./DrinkTive.vue?vue&type=template&id=987b7516", () => {
    api.rerender('987b7516', render)
  })

}


export default __exports__